<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { getPropertyCustomerRoleStatus } from "../../../../../../../../_shared/_logic/customer-roles"
  import type { CustomerRow } from "../../_shared/_logic/customers-table-contract"
  import { roleTooltipForEntries } from "../../_shared/_logic/object-presentation"

  let { row }: { row: CustomerRow } = $props()
  const roleValues = $derived(row.roleValues ?? [])
</script>

{#if roleValues.length}
  <span class="role-cell">
    {#each roleValues as role (`${row.id}-${role}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        status={getPropertyCustomerRoleStatus(role)}
        tooltipContent={roleTooltipForEntries(row.objectEntries ?? [], role)}
      />
    {/each}
  </span>
{:else}
  <span>–</span>
{/if}

<style lang="less">
  .role-cell {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    line-height: 1.25;
    white-space: normal;
  }
</style>
